import { useState, useEffect } from "react";

import axios from "axios";

import { useMsal } from "@azure/msal-react";
import { silentRequest } from "../../../authConfig";

// import * as signalR from "@microsoft/signalr";

import { Pagination } from "@fluentui/react-experiments/lib/Pagination";

import {
  DetailsListLayoutMode,
  ShimmeredDetailsList,
  SelectionMode,
  CommandBar,
  Stack,
  Pivot,
  PivotItem,
  Link,
  MessageBar,
  MessageBarType,
} from "@fluentui/react";

// const API_URL = process.env.REACT_APP_API_URL;
const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;

const homeStyles = {
  //width: '208',
  //height: '10vh',
  //width: 185,
  //height: 70,
  //boxSizing: 'border-box',
  //border: '1px solid #eee',
  //overflowY: 'auto',
  //paddingTop: '10vh',
  //background: '#FFFFFF',
  //background: '#106ebe',
  border: 0,
  /* paddingTop: '2%',
  paddingLeft: '2%',
  paddingRight: '2%', */
  margin: 0,
  //minHeight: '100vh',
  width: "100%",
  background: "#FAF9F8",
};

//ProgressIndicator
//const centerItem = { display: "flex", alignItems: "center", justifyContent: "center" };
//Progress Indicator Setting
//const intervalDelay = 100;
//const intervalIncrement = 0.01;

/* 
const shimmeredDetailsListProps = {
renderedWindowsAhead: 0,
renderedWindowsBehind: 0,
};
*/

const CertificateSubscriptionAccounts = (props) => {
  console.log("Home render!!!");

  const { instance } = useMsal();
  //const account = useAccount(accounts[0] || {});
  const account = instance.getAllAccounts()[0];

  //let token = b2cauth.getAccessToken();
  //console.log('Bearer', token);

  //const token = props.token;
  //const token = props.token;
  //

  //const api_key = props.api_key;
  //console.log('Api-Key:', props.api_key);

  //const items = [];
  const [items, setItems] = useState([]);
  const [loadDataComplete, setLoadDataComplete] = useState(false);
  const [getNewDocuments, setGetNewDocuments] = useState(true);
  // const [totalProcessingDocuments, setTotalProcessingDocuments] = useState(0);
  //const [clickDelete, setClickDelete] = useState(false);
  const [pageSize, setPageSize] = useState(
    sessionStorage.getItem('accounts-pageSize') * 1 || 10
  );
  const [currentPage, setCurrentPage] = useState(
    sessionStorage.getItem('accounts-currentPage') * 1 || 1
  );

  const [pageDropdown, setPageDropdown] = useState([]);

  const [copySuccess, setCopySuccess] = useState(false);

  const [primarySort, setPrimarySort] = useState("createdTime");
  const [isSortedDescendingCreatedTime, setIsSortedDescendingCreatedTime] = useState(false);
  const [isSortedDescendingNotBefore, setIsSortedDescendingNotBefore] = useState(false);
  const [isSortedDescendingNotAfter, setIsSortedDescendingNotAfter] = useState(true);

  const [sortDirection, setSortDirection] = useState("DESC")
  const [certificateStatus, setCertificateStatus] = useState({ key: "certificate-active", text: "ใบรับรองจริงที่เปิดใช้งาน"})
  const [deletedStatus, setDeletedStatus] = useState({ key: "deleted-false", text: "ยังไม่ถูกลบ"})
  
  const commandBarItems = [
    {
      key: certificateStatus.key,
      text: certificateStatus.text,
      cacheKey: "myCacheKey", // changing this key will invalidate this item's cache
      iconProps: { iconName: "Contact" },
      disabled: !loadDataComplete,
      subMenuProps: {
        items: [
          {
            key: "certificate-active",
            text: "ใบรับรองจริงที่เปิดใช้งาน",
            iconProps: { iconName: "Contact" },
            onClick: () => {
              setCertificateStatus({
                key: "certificate-active",
                text: "ใบรับรองจริงที่เปิดใช้งาน",
              })

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },
          {
            key: "certificate-all",
            text: "ใบรับรองจริงทั้งหมด",
            iconProps: { iconName: "Contact" },
            onClick: () => {
              setCertificateStatus({
                key: "certificate-all",
                text: "ใบรับรองจริงทั้งหมด",
              })

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },
          {
            key: "all",
            text: "ใบรับรองทั้งหมด",
            iconProps: { iconName: "Contact" },
            onClick: () => {
              setCertificateStatus({
                key: "all",
                text: "ใบรับรองทั้งหมด",
              })

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          }
        ],
      },
    },
    {
      key: deletedStatus.key,
      text: deletedStatus.text,
      cacheKey: "myCacheKey", // changing this key will invalidate this item's cache
      iconProps: { iconName: "Contact" },
      disabled: !loadDataComplete,
      subMenuProps: {
        items: [
          {
            key: "deleted-false",
            text: "ยังไม่ถูกลบ",
            iconProps: { iconName: "Contact" },
            onClick: () => {
              setDeletedStatus({
                key: "deleted-false",
                text: "ยังไม่ถูกลบ",
              })

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          },
          {
            key: "deleted-true",
            text: "ลบแล้ว",
            iconProps: { iconName: "Contact" },
            onClick: () => {
              setDeletedStatus({
                key: "deleted-true",
                text: "ลบแล้ว",
              })

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);
            },
            //['data-automation-id']: 'newEmailButton', // optional
          }
        ],
      },
    },
    {
      key: currentPage,
      text: "หน้า " + currentPage,
      iconProps: { iconName: "Page" },
      disabled: !loadDataComplete,
      subMenuProps: {
        items: pageDropdown,
      },
    },
    {
      key: "refresh",
      text: "รีเฟรช",
      iconProps: { iconName: "Refresh" },
      disabled: !loadDataComplete,
      onClick: () => {
        console.log("Refresh");

        setLoadDataComplete(false);
        setItems([]);
        setGetNewDocuments(true);
      },
    },
  ];

  const toThaiDateString = (isoDateTime) => {
    let date = "";
    date = new Date(isoDateTime);

    //console.log(dateTime.toLocaleDateString() + ' ' + dateTime.toLocaleTimeString());
    /* 
  let monthNames = [
    "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน",
    "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม",
    "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
  ];
*/
    let year = date.getFullYear() + 543;
    //let month = monthNames[date.getMonth()];
    let month = (date.getMonth() + 1).toString().padStart(2, "0");
    let numOfDay = date.getDate().toString().padStart(2, "0");

    let hour = date.getHours().toString().padStart(2, "0");
    let minutes = date.getMinutes().toString().padStart(2, "0");
    let second = date.getSeconds().toString().padStart(2, "0");

    return `${numOfDay}/${month}/${year} ${hour}:${minutes}:${second} น.`;
  };

  useEffect(() => {
    console.log("userEffect getNewDocuments Call!");

    if (getNewDocuments) {
      let certificatesListEndpoint = `${ADMIN_API_URL}/certificates`

      instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then(async (tokenResponse) => {
          // Do something with the tokenResponse
          console.log("Token response: ", tokenResponse);

            const [responseCertificatesList] = await Promise.all([
              axios
                .get(certificatesListEndpoint, {
                  params: {
                    status: certificateStatus.key,
                    deleted: deletedStatus.key === "deleted-true" ? "true" : "false",
                    offset: (currentPage - 1) * pageSize,
                    limit: pageSize,
                    sortDirection: sortDirection,
                    sortBy: primarySort
                  },
                  headers: {
                    Authorization: 'Bearer ' + tokenResponse.accessToken,
                  },
                })
                .catch((error) => console.log("error", error)),
            ]);
  
            console.log("responseCompaniesDetails", responseCertificatesList);
  
            const _total = responseCertificatesList.data.countTotal
  
            let _pageDropdown = [];
            for (let i = 1; i <= Math.ceil(_total / pageSize); i++) {
              _pageDropdown.push({
                key: i,
                text: 'หน้า ' + i,
                iconProps: { iconName: 'Page' },
                onClick: () => {
                  console.log('Selected page: ' + i);
                  setCurrentPage(i);
  
                  setLoadDataComplete(false);
                  setItems([]);
                  setGetNewDocuments(true);
                },
              });
            }
  
            setPageDropdown(_pageDropdown);
  
            if (currentPage > Math.ceil(_total / pageSize)) {
              setCurrentPage(1);
            }

            let _companyIdList = "";
            for (let j = 0; j < responseCertificatesList.data.certificates.length; j++) {
              if (j === 0) {
                _companyIdList = responseCertificatesList.data.certificates[j].companyId;
              } else {
                _companyIdList = _companyIdList + "," + responseCertificatesList.data.certificates[j].companyId;
              }
            }

            const responseCompanyDetailsList = await axios
              // .get(ADMIN_API_URL + "/companies?from=" + from + "&to=" + to + "&offset=" + (currentPage - 1) * pageSize + "&limit=" + pageSize, {
              // .get(`${ADMIN_API_URL}/packages/main?companyIdList=${_companyIdList}`, {
              .get(`${ADMIN_API_URL}/companies-details/?companyIdList=${_companyIdList}`, {
                headers: {
                  Authorization: "Bearer " + tokenResponse.accessToken,
                },
              })

            console.log("responseCompanyDetailsList", responseCompanyDetailsList);
  
            const _certificates = responseCertificatesList.data.certificates;
            let _docs = [];
  
            if (_certificates.length > 0) {
              const _companyDetailsList = responseCompanyDetailsList.data.documents;
              
              _certificates.forEach((_certificate, index) => {
                const _companyDetail = _companyDetailsList.find(_company => _company.id === _certificate.companyId);
                
                _docs.push({
                  key: _certificate.id,
                  ..._certificate,
                  companyDetail: _companyDetail
                });
              })
            }
  
            console.log("_docs", _docs);
  
            setItems(_docs);
  
            setLoadDataComplete(true);
            setGetNewDocuments(false);
          

        })
        .catch((error) => {
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          // instance.acquireTokenRedirect(silentRequest);
        });
    }
  }, [getNewDocuments]);

  const onPageChange = (selectedPageIndex) => {
    console.log("selectedPageIndex: ", selectedPageIndex);
    setCurrentPage(selectedPageIndex + 1);
    setGetNewDocuments(true);
    setItems([]);
    setLoadDataComplete(false);
  };

  const columns = [
    {
      key: "column2",
      name: "วันที่สร้าง",
      fieldName: "createdTime",
      minWidth: 60,
      maxWidth: 125,
      isResizable: true,
      isSorted: primarySort === "createdTime" ? true : false,
      isSortedDescending: isSortedDescendingCreatedTime,
      isSortedAscending: !isSortedDescendingCreatedTime,
      onColumnClick: () => {
        setPrimarySort("createdTime");
        setIsSortedDescendingCreatedTime(!isSortedDescendingCreatedTime);

        if (!isSortedDescendingCreatedTime) {
          setSortDirection('DESC');
        } else {
          setSortDirection('ASC');
        }

        setLoadDataComplete(false);
        setItems([]);
        setGetNewDocuments(true);
      },
      data: "number",
      onRender: (item) => {
        return <span>{item.createdTime ? toThaiDateString(item.createdTime) : "-"}</span>;
      },
    },
    {
      key: "column3",
      name: "วันที่เริ่มต้น",
      fieldName: "notBefore",
      minWidth: 60,
      maxWidth: 125,
      isResizable: true,
      isSorted: primarySort === "notBefore" ? true : false,
      isSortedDescending: isSortedDescendingNotBefore,
      isSortedAscending: !isSortedDescendingNotBefore,
      onColumnClick: () => {
        setPrimarySort("notBefore");
        setIsSortedDescendingNotBefore(!isSortedDescendingNotBefore);

        if (!isSortedDescendingNotBefore) {
          setSortDirection('DESC');
        } else {
          setSortDirection('ASC');
        }

        setLoadDataComplete(false);
        setItems([]);
        setGetNewDocuments(true);
      },
      data: "number",
      onRender: (item) => {
        return <span>{item.validity.notBefore ? toThaiDateString(item.validity.notBefore) : "-"}</span>;
      },
    },
    {
      key: "column4",
      name: "วันที่หมดอายุ",
      fieldName: "notAfter",
      minWidth: 60,
      maxWidth: 125,
      isResizable: true,
      isSorted: primarySort === "notAfter" ? true : false,
      isSortedDescending: isSortedDescendingNotAfter,
      isSortedAscending: !isSortedDescendingNotAfter,
      onColumnClick: () => {
        setPrimarySort("notAfter");
        setIsSortedDescendingNotAfter(!isSortedDescendingNotAfter);

        if (!isSortedDescendingNotAfter) {
          setSortDirection('DESC');
        } else {
          setSortDirection('ASC');
        }

        setLoadDataComplete(false);
        setItems([]);
        setGetNewDocuments(true);
      },
      data: "number",
      onRender: (item) => {
        return <span>{item.validity.notAfter ? toThaiDateString(item.validity.notAfter) : "-"}</span>;
      },
    },
    {
      key: "column5",
      name: "ชื่อใบรับรอง",
      fieldName: "certificateName",
      minWidth: 90,
      maxWidth: 200,
      isResizable: true,
      isSorted: false,
      isSortedDescending: true,
      onColumnClick: "",
      data: "string",
      onRender: (item) => {
        return <Link onClick={() => {
          navigator.clipboard.writeText(item.id);
          setCopySuccess(true);
          window.scrollTo(0, 0);
        }}>{item.certificateName}</Link>;
      },
    },
    {
      key: "column6",
      name: "Tax ID",
      fieldName: "organizationIdentifier",
      minWidth: 50,
      maxWidth: 120,
      isResizable: true,
      isSorted: false,
      isSortedDescending: true,
      onColumnClick: "",
      data: "string",
      onRender: (item) => {
        return <span>{item.subject?.organizationIdentifier || "-"}</span>;
      },
    },
    {
      key: "column7",
      name: "ประเภท",
      fieldName: "customerType",
      minWidth: 50,
      maxWidth: 125,
      isResizable: true,
      isSorted: false,
      isSortedDescending: true,
      onColumnClick: "",
      data: "string",
      onRender: (item) => {
        const _companyDetail = item.companyDetail
        if (_companyDetail) {
          if (_companyDetail.billings.type === "subscription") {
            if (_companyDetail.billings.manual || 
              _companyDetail.billings.manual === null || 
              _companyDetail.billings.manual === undefined) {
              return <span style={{ color: "green"}}>Subscription Manual</span>
            } else {
              return <span style={{ color: "green"}}>Subscription Auto</span>
            }
          } else if (_companyDetail.billings.type === "prepaid") {
            return <span style={{ color: "green"}}>Prepaid</span>
          } else if (_companyDetail.billings.type === "trial") {
            return <span>ทดลองใช้งาน</span>
          } else if (_companyDetail.billings.type === "expired") {
            return <span style={{ color: "red"}}>หมดอายุ</span>
          } else {
            return <span>-</span>;
          }
        } else {
          return <span>-</span>;

        }
      },
    },
    {
      key: "column8",
      name: "cid",
      fieldName: "cid",
      minWidth: 50,
      maxWidth: 250,
      isResizable: true,
      isSorted: false,
      isSortedDescending: true,
      onColumnClick: "",
      data: "string",
      onRender: (item) => {
        return <Link onClick={() => {
          navigator.clipboard.writeText(item.companyId);
          setCopySuccess(true);
          window.scrollTo(0, 0);
        }}>{item.companyId}</Link>;
      },
    },
  ];

  const isCompactMode = false;
  //const isModealSelection = false;
  //const annoucedMessage = undefined;

  return (
    <div style={homeStyles}>
      <Stack>
        {copySuccess &&

          <MessageBar

            messageBarType={MessageBarType.success}
            isMultiline={false}
            onDismiss={() => { setCopySuccess(false) }}
          >
            Copy สำเร็จ!
          </MessageBar>
        }
        <center>
          <h2 style={{ marginLeft: "0px", marginTop: "25px" }}>ใบรับรองอิเล็กทรอนิกส์</h2>
        </center>
      </Stack>


      <Stack horizontal horizontalAlign="center">
        <Stack
          vertical
          style={{
            width: "98%",
            //minWidth: '1070px',
            maxWidth: "1350px",
          }}
        >
          {/* <Stack horizontal className="ms-bgColor-white" horizontalAlign="space-between"> */}
          {/* <Stack horizontal className="ms-bgColor-white"> */}
          <Stack
            horizontal
            horizontalAlign="start"
            style={{
              backgroundColor: "#FFFFFF",
              // paddingLeft: '22px'
            }}
          >
            <CommandBar
              items={commandBarItems}
              styles={{
                root: {
                  // width: 668,
                  // width: "100%",
                },
              }}
            //overflowItems={_overflowItems}
            //overflowButtonProps={overflowProps}
            //farItems={_farItems}
            //ariaLabel="Use left and right arrow keys to navigate between commands"
            />

            {/* </div> */}
          </Stack>
          <Stack
            horizontal
            horizontalAlign="center"
            style={{
              backgroundColor: "#FFFFFF",
              // paddingLeft: '22px'
            }}
          >
            <Pivot
              // disabled={!loadDataComplete || isProcessDocument}
              selectedKey={String(pageSize)}
              onLinkClick={(item) => {
                console.log("Pivot item: ", item.props.itemKey);

                switch (item.props.itemKey) {
                  case "10":
                    console.log("10 เอกสาร/หน้า");
                    setPageSize(10);
                    sessionStorage.setItem('accounts-pageSize', 10);

                    setLoadDataComplete(false);
                    setItems([]);
                    setGetNewDocuments(true);

                    break;
                  case "30":
                    console.log("30 เอกสาร/หน้า");
                    setPageSize(30);
                    sessionStorage.setItem('accounts-pageSize', 30);

                    setLoadDataComplete(false);
                    setItems([]);
                    setGetNewDocuments(true);

                    break;
                  case "50":
                    console.log("50 เอกสาร/หน้า");
                    setPageSize(50);
                    sessionStorage.setItem('accounts-pageSize', 50);

                    setLoadDataComplete(false);
                    setItems([]);
                    setGetNewDocuments(true);

                    break;
                  default:
                }
              }}
            >
              <PivotItem headerText="10 เอกสาร/หน้า" itemIcon="NumberedList" itemKey="10" />
              {/* <PivotItem headerText="20 เอกสาร/หน้า" itemCount={42} itemIcon="Page"/>
                        <PivotItem headerText="30 เอกสาร/หน้า" itemCount={42} itemIcon="Page"/>
                        <PivotItem headerText="40 เอกสาร/หน้า" itemCount={42} itemIcon="Page"/> */}
              <PivotItem headerText="30 เอกสาร/หน้า" itemIcon="NumberedList" itemKey="30" />
              <PivotItem headerText="50 เอกสาร/หน้า" itemIcon="NumberedList" itemKey="50" />
            </Pivot>
          </Stack>
          <ShimmeredDetailsList
            items={items || []}
            enableShimmer={!loadDataComplete}
            compact={isCompactMode}
            columns={columns}
            selectionMode={SelectionMode.none}
            //selectionMode={SelectionMode.multiple}
            //getKey="1"
            //setKey="set"
            layoutMode={DetailsListLayoutMode.justified}
            isHeaderVisible={true}
          //selection={Selection}
          //selectionPreservedOnEmptyClick={true}
          //onItemInvoked={download}
          //enterModalSelectionOnTouch={true}
          //ariaLabelForSelectionColumn="Toggle selection"
          //ariaLabelForSelectAllCheckbox="Toggle selection for all items"
          //checkButtonAriaLabel="Row checkbox"
          //onRenderItemColumn={ this.onRenderItemColumn }
          //listProps={shimmeredDetailsListProps}
          />
        </Stack>
      </Stack>
      {/* </Fabric> */}
      <br />
      <center>
        {/* {!(documents.length === 0 || documents.length < pageSize) && */
          loadDataComplete && (
            <Pagination
              //selectedPageIndex={page}
              selectedPageIndex={currentPage - 1}
              //pageCount={pageCount}
              onPageChange={onPageChange}
              format
              firstPageIconProps={{
                iconName: "DoubleChevronLeft",
              }}
              previousPageIconProps={{ iconName: "ChevronLeft" }}
              nextPageIconProps={{ iconName: "ChevronRight" }}
              lastPageIconProps={{
                iconName: "DoubleChevronRight",
              }}
            />
          )}

        <br />
        <br />
      </center>
    </div>
  );
};

export default CertificateSubscriptionAccounts;
